const $html = $('html');
const cachedEnvironment = (
  (
    {
      language,
      isMobile = false,
      isPrivacyPage = false,
      isVerifaliaValidation = false
    }
  ) => {
    return {
      language,
      isMobile,
      isPrivacyPage,
      isVerifaliaValidation
    }
  }
)({
  language: $html.data('lang'),
  isMobile: window.matchMedia('(max-width:760px)').matches,
  isPrivacyPage: $html.data('controller') === 'PrivacyLoginController',
  isVerifaliaValidation: $html.data('verifalia-validation')
})

export const CURRENT_LANG = cachedEnvironment.language;
export const IS_EGON_VALIDATION = $html.data('egon-validation');
export const IS_EGON_VALIDATION__ZIP_BASED = $html.data('egon-zip-base');
export const IS_MOBILE = cachedEnvironment.isMobile;
export const IS_PRIVACY_PAGE = cachedEnvironment.isPrivacyPage;
export const IS_VERIFALIA_VALIDATION = cachedEnvironment.isVerifaliaValidation;
